import { render, staticRenderFns } from "./BookNoAccessPage.vue?vue&type=template&id=3a718ff7&"
import script from "./BookNoAccessPage.vue?vue&type=script&lang=js&"
export * from "./BookNoAccessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports